import { ViewStyle } from 'react-native';
import { IconKeyType } from 'shared/components/vxl/icon/Icon/Icon';

export enum SystemBannerType {
  INFO = 'INFO',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  BRAND = 'BRAND',
}

export interface SystemBannerProps {
  /** It act's as a iconKey for Icon component. Leading icon is configurable for all the banner types, also we have default icons set based on the banner type.  */
  iconKeyType?: IconKeyType;
  /** Indicates main title of the banner */
  titleText?: string;
  /** Body text of the banner */
  bodyText?: string;
  /** Type of the banner e.g .info, .success etc */
  bannerType: SystemBannerType;
  /** Analytic Id for key */
  analyticsId?: string;
  /** Analytic custom attributes */
  customAttributes?: Record<string, string>;
  /** Button prop accept Button component props as an argument. Use `Secondary` button type for SystemBanner*/
  button?: {
    label: string;
    onPress: () => void;
  };
  /** OnDismiss handler - Gets called when user dismiss the banner, non-nil onDismiss will show close icon on the banner */
  onDismiss?: () => void;
  /** OnCardPress handler - An optional handler gets called when user taps the whole card, non-nil onCardPress will show the chevron icon on the trailing side */
  onCardPress?: () => void;
}

export interface ComposableStyle {
  container: ViewStyle;
}

export interface AlignmentStyle {
  container: ViewStyle;
  innerContainer: ViewStyle;
}
